import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import toast from 'react-hot-toast';
import { WorkspacesStore } from '../../../DataSource/Stores/Cabinet/WorkspacesStore';
import { IWorkspace } from '../../../DataSource/Stores/Cabinet/WorkspacesStoreActionsClass';
import DeliveryCenter from '../DeliveryCenter';
import DistributionCenter from '../DistributionCenter';
import LanzhouReviews from '../LanzhouReviews';
import ShokolatyeCex from '../ShokolatyeCex';

type WorkspaceIdParams = {
  id?: string;
};

type WorkspaceContentProps = {
  workspaceId: string;
  name: string;
};

const Workspaces = () => {
  const { id } = useParams<WorkspaceIdParams>();

  useEffect(() => {
    if (!id) return;
    (async () => {
      if (!WorkspacesStore.dataListWork?.length) {
        await WorkspacesStore.getList();
      }

      try {
        const res = await WorkspacesStore.membersGet.call(id);
        WorkspacesStore.setMembers(res.data);
      } catch (e: any) {
        console.error(e);
        toast.error(e.message.message);
      }
    })();
  }, [id]);

  const workspace = WorkspacesStore.dataListWork.find((el) => el._id === id);

  const renderWorkspaceContent = (
    workspaceId?: string,
    currentWorkspace?: IWorkspace
  ): React.ReactNode => {
    if (!workspaceId || !currentWorkspace) return null;

    const props: WorkspaceContentProps = {
      workspaceId,
      name: currentWorkspace.name,
    };

    const { category } = currentWorkspace;

    if (
      (workspaceId === '66e170b52fc0a03d58789c24' ||
        workspaceId === '69f9bbecc8e6087739573ec3') &&
      category === 'order_management'
    ) {
      return <DistributionCenter {...props} />;
    }

    if (workspaceId === '67ef8a0d835120217b8c05d0' && category === 'inventors') {
      return <DistributionCenter {...props} />;
    }

    if (workspaceId === '680a0d7240d664b4503fa663' && category === 'hotel') {
      return <DistributionCenter {...props} />;
    }

    if (
      (workspaceId === '6707a212598d48bda5860bf0' ||
        workspaceId === '6720e7fa847708a28a16c731') &&
      category === 'delivery_center'
    ) {
      return <DeliveryCenter {...props} />;
    }

    if (workspaceId === '6732ed08a29f2065aeb56662' && category !== 'delivery_center') {
      return <ShokolatyeCex {...props} />;
    }

    if (workspaceId === '67220912e6bd539b6a9143bd' && category !== 'delivery_center') {
      return <LanzhouReviews {...props} />;
    }

    if (category === 'order_management') {
      return <DistributionCenter {...props} />;
    }

    return null;
  };

  return <>{renderWorkspaceContent(id, workspace)}</>;
};

export default observer(Workspaces);
